/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useRef} from 'react';
import {loadModules} from 'esri-loader';
import {LayerSettingsProps} from './LayerSettings';
import WeatherLayerSettings from './WeatherLayerSettings';

export type WeatherLayerContainerProps = LayerSettingsProps & {
  onOpacityChange: Function;
  onToggleExpand?: Function;
  opacity: number;
  url: string;
  expandedLayer: string
};

/**
 * @WeatherLayerContainer
 *
 * The Weather Layer Container provides a component which allows to instantiate
 * the wheather Layer and Map Layer Setting.
 *
 * ```typescript
 *
 *   <WeatherLayerContainer url={}
 *     isEnabled={}
 *     onToggle={}
 *     onOpacityChange={}
 *     opacity={}
 *     map={} />
 *
 * ```
 */
export const WeatherLayerContainer = ({
  map,
  url,
  layers,
  onToggle,
  onOpacityChange,
  onToggleExpand,
  opacity,
  isEnabled,
  expandedLayer
}: WeatherLayerContainerProps) => {
  const webTileLayerRef = useRef(null);

  useEffect(() => {
    loadModules(['esri/layers/WebTileLayer']).then(([WebTileLayer]) => {
      webTileLayerRef.current = WebTileLayer;
    });
  }, []);

  if (webTileLayerRef.current) {
    return (
      <WeatherLayerSettings webTileLayer={webTileLayerRef.current as any}
        isEnabled={isEnabled}
        url={url}
        onToggle={onToggle}
        onToggleExpand={onToggleExpand}
        onOpacityChange={onOpacityChange}
        opacity={opacity}
        layers={layers}
        map={map}
        expandedLayer={expandedLayer}/>
    );
  }
  return null;
};

export default WeatherLayerContainer;
